"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryIdentify = exports.registerItemData = exports.registerAll = exports.get = exports.dataListScrolls = exports.dataListPotions = exports.dataListSpawnable = exports.ERogueItemGroup = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var onceOnly_sidecar_1 = require("../../../lib/onceOnly-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueItemsData_potions_1 = require("./rogueItemsData_potions");
var rogueItemsData_scrolls_1 = require("./rogueItemsData_scrolls");
var ERogueItemGroup;
(function (ERogueItemGroup) {
    ERogueItemGroup[ERogueItemGroup["none"] = 0] = "none";
    ERogueItemGroup[ERogueItemGroup["gold"] = 1] = "gold";
    ERogueItemGroup[ERogueItemGroup["scroll"] = 2] = "scroll";
    ERogueItemGroup[ERogueItemGroup["potion"] = 3] = "potion";
    ERogueItemGroup[ERogueItemGroup["corpse"] = 4] = "corpse";
    ERogueItemGroup[ERogueItemGroup["rift"] = 5] = "rift";
    ERogueItemGroup[ERogueItemGroup["upgrade"] = 6] = "upgrade";
    ERogueItemGroup[ERogueItemGroup["furniture"] = 7] = "furniture";
    ERogueItemGroup[ERogueItemGroup["weapon"] = 8] = "weapon";
})(ERogueItemGroup = exports.ERogueItemGroup || (exports.ERogueItemGroup = {}));
var _default = {
    group: ERogueItemGroup.none,
    type: 'default',
    name: 'default',
    description: 'default',
    char: '!',
    sprite: rogueMonofont_sidecar_1.rogueMonofont.getSprite('!'),
    sprite2: null,
    color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
    spawnChance: 1,
    isPetCorpse: false,
    isBurnable: false,
    onUse: function () { },
};
var dataType = 'items';
var dataList = [];
exports.dataListSpawnable = [];
exports.dataListPotions = [];
exports.dataListScrolls = [];
var dataMapType = {};
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
};
exports.get = get;
var registerAll = function () {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    (0, exports.registerItemData)({
        group: ERogueItemGroup.gold,
        type: 'gold',
        description: 'A pile of gold',
        name: 'gold',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        sprite: sprites_sidecar_1.sprites.rogue03,
        isBurnable: true,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.weapon,
        type: 'fireaxe',
        description: 'An axe for attacking fire and walls',
        name: 'fireaxe+1',
        color: rogueDef_sidecar_1.rogueDef.colors.red,
        char: 'x',
        // isBurnable: true,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.corpse,
        type: 'ex-dog',
        description: 'An ex-dog',
        name: 'ex-dog',
        color: rogueDef_sidecar_1.rogueDef.colors.pureBlack,
        char: 'x',
        isPetCorpse: true,
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.corpse,
        type: 'ex-cat',
        description: 'An ex-cat',
        name: 'ex-cat',
        color: rogueDef_sidecar_1.rogueDef.colors.pureBlack,
        char: 'x',
        isPetCorpse: true,
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.corpse,
        type: 'ex-birb',
        description: 'This is an ex-parrot!',
        name: 'ex-birb',
        color: rogueDef_sidecar_1.rogueDef.colors.pureBlack,
        char: 'x',
        isPetCorpse: true,
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.corpse,
        type: 'ex-wizard',
        description: 'An ex-wizard',
        name: 'ex-wizard',
        color: rogueDef_sidecar_1.rogueDef.colors.pureBlack,
        char: 'x',
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.corpse,
        type: 'ex-item',
        description: 'A burnt item',
        name: 'ex-item',
        color: rogueDef_sidecar_1.rogueDef.colors.brown,
        char: 'x',
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.rift,
        type: 'rift',
        description: 'A rift to a new house',
        name: 'rift',
        color: rogueDef_sidecar_1.rogueDef.colors.dark,
        char: 'O',
        sprite: sprites_sidecar_1.sprites.rogue53,
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.upgrade,
        type: 'spell-point',
        description: 'A point to buy spells',
        name: 'skill point',
        color: rogueDef_sidecar_1.rogueDef.colors.pureWhite,
        char: 'o',
        sprite: sprites_sidecar_1.sprites.rogue201,
        // sprite: sprites.rogue03,
    });
    (0, exports.registerItemData)({
        group: ERogueItemGroup.furniture,
        type: 'toilet',
        description: 'A water source to replenish spells',
        name: 'toilet',
        color: rogueDef_sidecar_1.rogueDef.colors.light,
        char: 'T',
        // sprite: sprites.rogue201,
        // sprite: sprites.rogue03,
    });
    (0, rogueItemsData_potions_1.registerPotions)();
    (0, rogueItemsData_scrolls_1.registerScrolls)();
};
exports.registerAll = registerAll;
var registerItemData = function (data) {
    assert_sidecar_1.assert.notNil(data.type);
    if (!data.char) {
        data.char = data.type;
    }
    if (!data.name) {
        data.name = '' + data.type;
    }
    if (!data.sprite) {
        data.sprite = rogueMonofont_sidecar_1.rogueMonofont.getSprite(data.char);
    }
    var merged = entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
    if (merged.group === ERogueItemGroup.potion) {
        exports.dataListPotions.push(merged);
    }
    if (merged.group === ERogueItemGroup.scroll) {
        exports.dataListScrolls.push(merged);
    }
    if (merged.spawnChance > 0) {
        exports.dataListSpawnable.push(merged);
    }
};
exports.registerItemData = registerItemData;
var tryIdentify = function (item) {
    if (!item.variant) {
        return;
    }
    if (!item.variant.isIdentified) {
        item.variant.isIdentified = true;
        rogueStats_sidecar_1.rogueStats.setMessage('It is a ' + item.variant.data.name + '!');
    }
};
exports.tryIdentify = tryIdentify;
